export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14606.6d541f1a.jpg";